export type ConfigProps = {
    type: 'seller'|'ext'
}

const config = {
    APP_BASENAME: '/nase3-latest-rozcestnik'
}

export default config;
